export default "__VITE_ASSET__DVv1Ai2v__"